import { render, staticRenderFns } from "./LmDocumentsNewOrEdit-2.vue?vue&type=template&id=f996bbba&scoped=true"
import script from "./LmDocumentsNewOrEdit-2.vue?vue&type=script&lang=js"
export * from "./LmDocumentsNewOrEdit-2.vue?vue&type=script&lang=js"
import style0 from "./LmDocumentsNewOrEdit-2.vue?vue&type=style&index=0&id=f996bbba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f996bbba",
  null
  
)

export default component.exports